import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route} from 'react-router-dom'
import {CookiesProvider, Cookies} from 'react-cookie';
import {Provider} from 'react-redux';
import store from './store/';
import {AUTH_USER} from './store/auth/types';
import App from './containers/application/App/App';
import {refreshUser} from './store/auth/actions'
import 'typeface-roboto'
import 'flexboxgrid/css/flexboxgrid.css';
import './resources/css/index.css';
import i18n from "i18next";
import {reactI18nextModule} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import {ENV_PROD} from "./constants/env";

// JWT Token
const cookies = new Cookies();
const user = cookies.get('user');
const refresh = cookies.get('refresh');
if (user) {
    store.dispatch({type: AUTH_USER, payload: user});
} else if (refresh) {
    store.dispatch(refreshUser());
}

// i18n
i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(reactI18nextModule) // if not using I18nextProvider
    .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV !== ENV_PROD,
        interpolation: {
            escapeValue: false, // not needed for react!!
        },
        escapeValue: false,

        // react i18next special options (optional)
        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    });

let node = (
    <CookiesProvider>
        <Provider store={store}>
            <BrowserRouter>
                <Route path="/" component={App}/>
            </BrowserRouter>
        </Provider>
    </CookiesProvider>
);

ReactDOM.render(node, document.getElementById('root'));



// WEBPACK FOOTER //
// src/index.js